/*------------------------------------------------------------------------------------------
* © 2020 KPMG LLP, a Delaware limited liability partnership and 
* a member firm of the KPMG global organization of independent member firms 
* affiliated with KPMG International Limited, a private English company limited by guarantee. 
* All rights reserved.
*-----------------------------------------------------------------------------------------*/
export class AzureConfig{
    isCloud: boolean;
    tenant: string;
    clientId: string;
    endpoints: any;
}

export class SearchProperties{
    operators: string[];
    clauses: string[];
    fieldsEVS: string[];
    fieldsTax: string[];
}

export class FilterFields{
    Clause: string[];
    EVS:FilterFieldProperties[];
    TAX:FilterFieldProperties[];
}

export class FilterFieldProperties{
    fieldName: string;
    operators: string[];
    value: string;
}
